import './App.css';
import { Brandcard, Featurecard, Navbar, Roadmapcard, Teamcard, Whitepaper } from './components'
import { About, Extra, Features, Roadmapsec, Footer, Header, Partners, Team } from './containers'



function App() {
  return (
    <div className="App">
      <div className='gradient__bg'>
        <Navbar />
        <Header />
      </div>
      <Extra />
      <Whitepaper />
      <About />
      <div className='p-6'>
        <Brandcard />
      </div>
      <Features />
      <Roadmapsec />
      {/* <Team /> */}
      <Partners />
      <Footer />
     
     
      
    </div>
    
  );
}

export default App;
